import { useDefectRepairV1ControllerCreate } from 'generated/apiComponents';

export const useCreateRepairMutation = () => {
  const { mutateAsync, isPending } = useDefectRepairV1ControllerCreate();

  return {
    createRepair: mutateAsync,
    isLoading: isPending,
  };
};
